module.exports = __webpack_public_path__ + "static/media/features-split-image-03.74231ce3.png";